'use strict';

( function ( $ ) {
	const accordion = $( '.repeater-content-image__accordion' );

	if ( ! accordion.length ) {
		return;
	}

	const items = accordion.find( '.repeater-content-image__accordion-item' );

	items.each( function () {
		const item = $( this );
		const heading = item.find(
			'.repeater-content-image__accordion-heading'
		);
		const content = item.find(
			'.repeater-content-image__accordion-content'
		);
		const icon = heading.find( '.repeater-content-image__accordion-icon' );

		// If the content is active on page load, hide it and then show it with slideDown
		// to ensure the height is calculated correctly for the slideUp animation.
		if ( content.hasClass( 'active' ) ) {
			content.hide().slideDown( 0 );
		}

		heading.on( 'click', function () {
			const clickedHeading = $( this );

			if ( clickedHeading.hasClass( 'active' ) ) {
				heading.removeClass( 'active' );
				icon.removeClass( 'active' );

				content.slideUp( 300, function () {
					content.removeClass( 'active' );
				} );
			} else {
				// Close other items
				const otherActiveItems = items
					.siblings()
					.find(
						'.repeater-content-image__accordion-heading.active'
					);
				otherActiveItems.each( function () {
					const otherHeading = $( this );
					const otherItem = otherHeading.closest(
						'.repeater-content-image__accordion-item'
					);
					const otherContent = otherItem.find(
						'.repeater-content-image__accordion-content'
					);
					const otherIcon = otherHeading.find(
						'.repeater-content-image__accordion-icon'
					);

					otherHeading.removeClass( 'active' );
					otherIcon.removeClass( 'active' );

					otherContent.slideUp( 300, function () {
						otherContent.removeClass( 'active' );
					} );
				} );

				// Open this item
				heading.addClass( 'active' );
				icon.addClass( 'active' );

				content.slideDown( 300, function () {
					content.addClass( 'active' );
				} );
			}
		} );
	} );
} )( jQuery );
